import { useUser } from "@/features/auth/hooks/useUser";
import style from "./ReviewCard.module.css";

import Icon from "@/ui/icon/Icon";
import { formatTimeAgo } from "@/i18n/format";
import { useCurrentLanguage, useLocalized } from "@/i18n/useLocalized";
import MoreOptions from "../moreOptions/MoreOptions";
import { Trans, useTranslation } from "react-i18next";

function ReviewCard({ review, course }) {
	const { t } = useTranslation();
	const { user } = useUser();
	const language = useCurrentLanguage();
	const l = useLocalized();

	const imgUrl = review?.user?.safe_picture_url;
	const name = review?.user?.username;
	const date = formatTimeAgo(new Date(review?.timestamp).getTime(), language);
	const rating = review?.stars;
	const text = l(review, "content");
	const canDelete = review?.user?.username == user?.username;

	return (
		<div className={style.review}>
			<div className={style.header}>
				<div className={style.user}>
					<div className={style.imgHolder}>
						<img src={imgUrl} alt={t("reviews:reviewCard.avatarAlt", { name })} />
					</div>
					<div className={style.userInfo}>
						<div className={style.name}>{name}</div>
						<div className={style.date}>{date}</div>
					</div>
				</div>
				{canDelete && <MoreOptions course={course} />}
			</div>
			<div className={style.body}>
				<div className={style.starsHolder}>
					<div
						className={style.stars}
						style={{ "--rating": rating }}
					></div>
					<div>
						<Trans
							i18nKey="reviews:reviewCard.rated"
							values={{ rating }}
							components={{ rating: <span /> }}
						/>
					</div>
				</div>
				<div className={style.text}>{text}</div>
			</div>
		</div>
	);
}

export default ReviewCard;
